import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Alert, Button, Paper, Stack, TextField, Typography,
} from '@mui/material';
import { request } from './OperationsProvider';
import { formatDateTime } from '../common/util/datetime';
import useDraft from '../common/util/useDraft';

export default function HandoverPanel({ gate, updatedAt }) {
  const user = useSelector((state) => state.session.user);
  const [draft, setDraft, discard] = useDraft(`handover.${gate || 'unselected'}`, { note: '', shift: '' });
  const [rows, setRows] = useState([]); const [error, setError] = useState('');
  const [pending, setPending] = useState(false); const [saved, setSaved] = useState(false);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const controller = new AbortController(); setRows([]); setError('');
    request(`/api/operations/handovers?checkpointId=${encodeURIComponent(gate)}`, 'GET', null, controller.signal)
      .then(setRows).catch((e) => { if (e.name !== 'AbortError') setError(e.message); });
    return () => controller.abort();
  }, [gate, updatedAt, revision]);
  const act = async (path, body) => {
    setPending(true); setError(''); setSaved(false);
    try { await request(`/api/operations/${path}`, 'POST', body); if (path === 'handovers') discard(); setSaved(true); setRevision((n) => n + 1); } catch (e) { setError(e.message); } finally { setPending(false); }
  };
  return (
    <Paper variant="outlined" sx={{ p: 2, mt: 3 }}>
      <Typography variant="h6">Shared shift handover</Typography>
      {error && <Alert severity="error">{error}</Alert>}
      {saved && <Alert severity="success">Handover saved.</Alert>}
      <Stack component="form" gap={2} sx={{ mt: 2 }} onSubmit={(e) => { e.preventDefault(); act('handovers', { ...draft, checkpointId: Number(gate) }); }}>
        <TextField required label="Shift / receiving shift" value={draft.shift} onChange={(e) => setDraft({ ...draft, shift: e.target.value })} inputProps={{ maxLength: 100 }} />
        <TextField required label="Unresolved work and handover note" multiline minRows={3} value={draft.note} onChange={(e) => setDraft({ ...draft, note: e.target.value })} inputProps={{ maxLength: 500 }} />
        <Button type="submit" variant="contained" disabled={pending || !gate || !updatedAt}>Publish handover for this gate</Button>
        {!gate && <Typography>Choose your gate above to publish a handover.</Typography>}
      </Stack>
      {rows.map((row) => (
        <Paper key={row.id} variant="outlined" sx={{ p: 2, mt: 2 }}>
          <Typography fontWeight={600}>{`${row.shift} · ${row.site} · ${row.gate}`}</Typography>
          <Typography sx={{ whiteSpace: 'pre-wrap' }}>{row.note}</Typography>
          <Typography variant="caption">{`${row.createdByName} · ${formatDateTime(row.createdAt)}`}</Typography>
          {row.acknowledgedAt ? <Typography>{`Received by ${row.acknowledgedByName} · ${formatDateTime(row.acknowledgedAt)}`}</Typography>
            : <Button disabled={pending || row.createdBy === user.id} onClick={() => act(`handovers/${row.id}/acknowledge`, {})}>Acknowledge receipt</Button>}
        </Paper>
      ))}
    </Paper>
  );
}
